import { TemplateConfig } from '../types';

export const christmasLoveConfig: TemplateConfig = {
  id: 'christmas-love',
  name: '圣诞之爱',
  description: '分析感情现状与未来发展趋势',
  cardCount: 6,
  
  fieldDefaults: {
    title: '圣诞之爱',
    customerQuestion: '分析我和对方的感情现状和未来发展趋势。',
    cardPlaceholders: [
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 5 列第 1 张牌'
    ],
    cardInfos: [
      '1.你现在对对方的真实感情。',
      '2.对方对你当前的真实感受。',
      '3.你吸引对方的地方。',
      '4.当前感情中的主要阻碍或隐藏的问题。',
      '5.相处中你该采取的行动或表达方式。',
      '6.这段关系在接下来的发展趋势。'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#cf1322',
    backgroundColor: '#fff1f0',
    icon: '🎁'
  }
};
